import { useCallback, useEffect, useState } from 'react';
import { ApiBulkSession } from '@agunity/api-v4';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';
import { Grid } from '@mui/material';

import Header from './Header';
import Count from './Count';
import Errors from './Errors';
import AgLoadingCard from '../../../stories/AgLoadingCard';

import { useAppDispatch } from '../../../redux/hooks';
import { useToast } from '../../../redux/hooks/toast';
import { setHeaderName } from '../../../redux/slices/navigation';
import { getBulkUploadRequestDetails, postBulkUploadRequestCommit } from '../redux';
import * as S from './styled';

const BulkUploadRequestDetails = () => {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const { formatMessage } = useIntl();
  const { toast } = useToast();

  const [details, setDetails] = useState<ApiBulkSession>({});
  const [isLoading, setIsLoading] = useState(false);

  const hasCount = (details?.memberCount || 0) > 0 || (details?.staffCount || 0) > 0 || (details?.orgCount || 0) > 0;

  const handleGetDetails = useCallback(async () => {
    try {
      setIsLoading(true);
      dispatch(setHeaderName(''));
      const response = await dispatch(getBulkUploadRequestDetails(id as string));
      setDetails(response.data || {});
    } catch (error) {
      console.error('Failed to fetch bulkUploadRequestDetails: ', error);
    } finally {
      setIsLoading(false);
    }
  }, [dispatch, id]);

  const handleSubmit = useCallback(async () => {
    try {
      const response = await dispatch(postBulkUploadRequestCommit(id as string));
      const isAsync = response.data?.isAsync;

      toast('success', formatMessage({ id: `BULK_UPLOAD_REQUEST_SUCCESS_${isAsync ? 'ASYNC_MESSAGE' : 'MESSAGE'}` }));
    } catch (error) {
      console.error('Failed to submit bulkUploadRequestDetails: ', error);
      toast('error', formatMessage({ id: 'BULK_UPLOAD_REQUEST_FAILED_TO_SUBMIT' }));
    } finally {
      await handleGetDetails();
    }
  }, [dispatch, formatMessage, handleGetDetails, id, toast]);

  useEffect(() => {
    handleGetDetails();
  }, [handleGetDetails]);

  if (isLoading) return <AgLoadingCard text={formatMessage({ id: 'LOADING' })} />;

  return (
    <S.Main>
      <Grid container xs={12} spacing={2} sx={S.contentStyle}>
        <Header details={details} onSubmit={handleSubmit} />
        {hasCount && <Count details={details} />}
        <Errors details={details} />
      </Grid>
    </S.Main>
  );
};

export default BulkUploadRequestDetails;